var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowMenuOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#D5DDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38542 14.8021H17.3447L13.4305 18.7162C13.1177 19.029 13.1177 19.5424 13.4305 19.8552C13.7433 20.168 14.2486 20.168 14.5615 19.8552L19.8472 14.5695C20.16 14.2566 20.16 13.7513 19.8472 13.4385L14.5695 8.14477C14.2567 7.83195 13.7514 7.83195 13.4385 8.14477C13.1257 8.45758 13.1257 8.96289 13.4385 9.2757L17.3447 13.1979H8.38542C7.94427 13.1979 7.58333 13.5588 7.58333 14C7.58333 14.4411 7.94427 14.8021 8.38542 14.8021Z",
    fill: "#D5DDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuOpen);
export default __webpack_public_path__ + "static/media/arrow_menu_open.b62e3e63da66f0b37175cc29568cc21b.svg";
export { ForwardRef as ReactComponent };